import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TOAST_DEFAULT_POSITION, TOAST_CONTAINER_DIV_CONTENT } from './Toast.constants';
import { createPortal } from 'react-dom';
import { ToastContainer, ToastRoot } from './Toast.styled';
import { useToast } from './Toast.hooks';
// Component.
// -----------------------------------------------------------------------------
/**
 * In order to use it, it is necessary to render the `Toast` component in the
 * application. Subsequently, messages can be sent with the functions provided
 * by the hook useToast.
 */
const Toast = forwardRef(({ position = TOAST_DEFAULT_POSITION }, ref) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { node } = useToast({ position });
    // Guard Condition.
    // ---------------------------------------------------------------------------
    if (!node) {
        return null;
    }
    // Render.
    // ---------------------------------------------------------------------------
    return createPortal(_jsx(ToastRoot, { position: position, ref: ref, children: _jsx(ToastContainer, { id: TOAST_CONTAINER_DIV_CONTENT, position: position }) }), node);
});
// Component configuration.
// -----------------------------------------------------------------------------
Toast.displayName = 'Toast';
export default Toast;
//# sourceMappingURL=Toast.js.map